import React, { useState } from 'react'

import { useIsSmallDevice } from '../../hookreducer/hooks'

import StyleMenu from './StyleMenu'
import BoardsMenu from './BoardsMenu'
import WallBaseMenu from './WallBaseMenu'
import AccessoriesMenu from './AccessoriesMenu'
import DecorMenu from './DecorMenu'
import BoxModal from '../elements/BoxModal'
import CalculatorModal from '../elements/CalculatorModal'

const Elements = ({
  addElement,
  currentStep,
  setShortkeys,
  metalColor, setMetalColor,
  woodColor, setWoodColor,
  setTag, isTagged,
  setQuotes, isQuotes,
  addBox,
}) => {
  const [showCalculatorModal, setShowCalculatorModal] = useState(false)
  const [showBoxModal, setShowBoxModal] = useState(false)

  const isSmall = useIsSmallDevice()

  return (
    <>
      <div style={{
        height: isSmall ? '74px' : '800px',
        overflow: 'scroll',
      }}
      >
        {{

          1: <WallBaseMenu
            addElement={addElement}
            setShowCalculatorModal={setShowCalculatorModal}
            setShortkeys={setShortkeys}
            setShowBoxModal={setShowBoxModal}
            setTag={setTag}
            isTagged={isTagged}
            setQuotes={setQuotes}
            isQuotes={isQuotes}
            metalColor={metalColor}
            woodColor={woodColor}
            setWoodColor={setWoodColor}
            setMetalColor={setMetalColor}
          />,
          2: <BoardsMenu
            addElement={addElement}
            setTag={setTag}
            isTagged={isTagged}
            setQuotes={setQuotes}
            isQuotes={isQuotes}
            metalColor={metalColor}
            woodColor={woodColor}
            setWoodColor={setWoodColor}
            setMetalColor={setMetalColor}
          />,
          3: <AccessoriesMenu
            addElement={addElement}
            setTag={setTag}
            isTagged={isTagged}
            setQuotes={setQuotes}
            isQuotes={isQuotes}
            metalColor={metalColor}
            woodColor={woodColor}
            setWoodColor={setWoodColor}
            setMetalColor={setMetalColor}
          />,
          4: <DecorMenu
            addElement={addElement}
            setTag={setTag}
            isTagged={isTagged}
            setQuotes={setQuotes}
            isQuotes={isQuotes}
            metalColor={metalColor}
            woodColor={woodColor}
            setWoodColor={setWoodColor}
            setMetalColor={setMetalColor}
          />,
          0: <StyleMenu
            metalColor={metalColor}
            woodColor={woodColor}
            setWoodColor={setWoodColor}
            setMetalColor={setMetalColor}
          />,
        }[currentStep]}
      </div>
      <BoxModal
        show={showBoxModal}
        addBox={(dim) => { addBox(dim); setShowBoxModal(false); setShortkeys(true) }}
        cancel={() => { setShowBoxModal(false); setShortkeys(true) }}
      />

      <CalculatorModal
        show={showCalculatorModal}
        handleClose={() => setShowCalculatorModal(false)}
      />
    </>
  )
}


export default Elements
